























import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import treeNodeHoverEstimate from '@/components/common/tree-node-hover-estimate/index.vue';
import { AdgroupFormData, InterestOption } from '@tt4b/ttam-enums';
const name = 'ttam-interests-in-market-category';

export default defineComponent({
  name,
  components: {
    treeNodeHoverEstimate,
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      required: true,
    },
    options: {
      type: Array as PropType<InterestOption[]>,
      required: true,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props, { emit }) {
    const _value = computed({
      get: () => props.value,
      set: v => {
        emit('change', v);
        emit('input', v);
      },
    });
    const searchInMarket = keyword => {
      emit('search', keyword);
    };
    const treeNodeHoverEstimateRef = ref();

    function onMouseEnterNode(node) {
      const hoverNodeData = node?.data ?? {};
      treeNodeHoverEstimateRef.value?.showHoverEstimate(hoverNodeData);
    }
    return {
      name,
      _value,
      treeNodeHoverEstimateRef,
      onMouseEnterNode,
      searchInMarket,
    };
  },
});
